import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { IBasketDispatch, IContract, IContractVariation, IDispatchNote, IDispatchRequest, IMaterial, IMaterialAudit, IMaterialConsumeData, IMaterialGroup, ISearchRequest, ISearchResultOption, IStorageRequest, IUser } from "./interfaces";
import { IReportRequest } from "./interfaces/Report/IReportRequest";

//const pca = new PublicClientApplication(msalConfig);
//const accounts = pca.getAllAccounts();

async function getIdToken() {

    const pca = new PublicClientApplication(msalConfig);
    const accounts = pca.getAllAccounts();

    if (accounts.length > 0) {
        const request = {
            scopes: ["openid"],
            account: accounts[0],
            forceRefresh: true
        }
        const idToken = await pca.acquireTokenSilent(request).then(async (response: any) => {

            const tokenExpiryTime = new Date(response.expiresOn).getTime();
            const currentTime = new Date().getTime();

            if (tokenExpiryTime <= currentTime) {
                console.log("attempting reauthentication - token has expired: ", new Date(response.expiresOn).toLocaleString());
                try {
                    await pca.loginPopup({
                        scopes: ["openid"],
                    });
                } catch (popupError) {
                    console.log("attempting loginRedirect - loginPopup failed: ", popupError);
                    await pca.loginRedirect({
                        scopes: ["openid"],
                    });
                }
            }

            return response.idToken;

        }).catch(error => {
            // Do not fallback to interaction when running outside the context of MsalProvider. Interaction should always be done inside context.
            console.log(error);

            return null;
        });
        return idToken;
    }

    return null;
}

async function getHeaders() {

    const token = await getIdToken();

    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
}
async function getFormHeaders() {

    const token = await getIdToken();

    return {
        // 'Content-Type': ' multipart/form-data',
        'Authorization': 'Bearer ' + token
    }
}

export interface IPagedRequest {
    page: number;
    pageSize: number;
    search?: string;
    sortField?: string;
    sortDirection?: "asc" | "desc";
}

export interface IPagedResult<T> {
    items: T[];
    totalCount: number;
    page: number;
    pageSize: number;
}

const getPagedQueryString = (request: IPagedRequest) => {
    const params = new URLSearchParams();

    params.set("page", request.page.toString());
    params.set("pageSize", request.pageSize.toString());

    if (request.search)
        params.set("search", request.search);

    if (request.sortField)
        params.set("sortField", request.sortField);

    if (request.sortDirection)
        params.set("sortDirection", request.sortDirection);

    return params.toString();
}

const Api = {
    Audits: {
        getByStatus: async (status: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/audits/status/${status}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        getByStatusPaged: async (status: string, request: IPagedRequest) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/audits/status/${status}/page?${getPagedQueryString(request)}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        get: async (materialAuditId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/audits/' + materialAuditId, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        create: async (request: ISearchRequest, options: ISearchResultOption[]) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/audits/create', {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({
                            searchRequest: request,
                            searchOptions: options
                        })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        save: async (audit: IMaterialAudit) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                console.log(audit);

                try {
                    fetch('api/v1/audits', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(audit)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        delete: async (materialAuditId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/audits/delete', {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ materialAuditId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },

        close: async (materialAuditId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/audits/close', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ materialAuditId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },

        export: async (materialAuditId: string) => {


            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/audits/export/', {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ materialAuditId })
                    }).then((response) => response)
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        import: async (form: FormData) => {
            let headers = await getFormHeaders();


            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/audits/import`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: form,
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        }
    },
    Basket: {
        dispatch: async (request: IBasketDispatch) => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/Basket/dispatchrequest', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(request)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        dispatchToContract: async (request: IBasketDispatch) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/Basket/contract', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(request)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        dispatchToContractVariation: async (request: IBasketDispatch) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/Basket/contractvariation', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(request)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        dispatchToStorageRequest: async (request: IBasketDispatch) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/Basket/storagerequest', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(request)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
    },
    Contracts: {
        getByStatus: async (status: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/contracts/status/${status}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        get: async (contractId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/contracts/' + contractId, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        create: async () => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/contracts/draft', {
                        method: 'POST',
                        headers: headers,

                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: null
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        save: async (contract: IContract) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/contracts', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(contract)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        submit: async (contractId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/contracts/submit', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ contractId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        delete: async (contractId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/contracts/delete', {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ contractId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        approve: async (contractId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/contracts/approve', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ contractId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        reject: async (contractId: string, reason: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/contracts/reject', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ contractId, reason })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        close: async (contractId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/contracts/close', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ contractId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },

        Variation: {
            getByStatus: async (contractId: string, status: string) => {

                let headers = await getHeaders();

                let specificContractEndpoint = contractId.length === 0 ? "" : (contractId + "/");

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${specificContractEndpoint}variations/status/${status}`, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);
                    }
                });
            },
            getByContractId: async (contractId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations`, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);
                    }
                });
            },
            get: async (contractId: string, contractvariationId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations/${contractvariationId}`, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {
                        return reject(err);
                    }
                });
            },
            create: async (contractId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations/draft`, {
                            method: 'POST',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer'
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {
                        return reject(err);
                    }
                });
            },
            save: async (contractVariation: IContractVariation) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {

                    try {
                        fetch(`api/v1/contracts/${contractVariation.contract.contractId}/variations/${contractVariation.contractVariationId}`, {
                            method: 'PUT',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify(contractVariation)
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        console.log(err);
                        return reject(err);

                    }
                });
            },
            end: async (contractVariation: IContractVariation, consumedMaterialReason: string, createContract: boolean) => {

                let headers = await getHeaders();

                // TODO: Eric - I've just quickly added these here so that I can test the end contract options.
                contractVariation.consumedMaterialReason = consumedMaterialReason;
                contractVariation.createContract = createContract;

                return new Promise((resolve, reject) => {

                    try {
                        fetch(`api/v1/contracts/${contractVariation.contract.contractId}/variations/${contractVariation.contractVariationId}/end`, {
                            method: 'PUT',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify(contractVariation)
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        console.log(err);
                        return reject(err);

                    }
                });
            },
            submit: async (contractId: string, contractVariationId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations/{${contractVariationId}}/submit`, {
                            method: 'PUT',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify({ contractVariationId })
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {
                        return reject(err);
                    }
                });
            },
            delete: async (contractId: string, contractVariationId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations/{${contractVariationId}}/delete`, {
                            method: 'DELETE',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify({ contractVariationId })
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {
                        return reject(err);
                    }
                });
            },
            approve: async (contractId: string, contractVariationId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations/{${contractVariationId}}/approve`, {
                            method: 'PUT',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify({ contractVariationId })
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);

                    }
                });
            },
            reject: async (contractId: string, contractVariationId: string, reason: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations/{${contractVariationId}}/reject`, {
                            method: 'PUT',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify({ contractVariationId, reason })
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);

                    }
                });
            },
            close: async (contractId: string, contractVariationId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/contracts/${contractId}/variations/{${contractVariationId}}/close`, {
                            method: 'PUT',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify({ contractVariationId })
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);

                    }
                });
            },
        }
    },
    Dispatches: {
        getByStatus: async (status: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/dispatches/status/${status}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        getByStatusPaged: async (status: string, request: IPagedRequest) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/dispatches/status/${status}/page?${getPagedQueryString(request)}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        get: async (dispatchRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/' + dispatchRequestId, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        create: async () => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/dispatches/draft', {
                        method: 'POST',
                        headers: headers,

                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: null
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        save: async (dispatch: IDispatchRequest) => {

            let headers = await getHeaders();
            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(dispatch)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        extend: async (dispatch: IDispatchRequest) => {

            let headers = await getHeaders();
            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/extend', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(dispatch)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        consume: async (dispatchRequestId: string, materialData: IMaterialConsumeData[], consumeReason: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/consume', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId, materialData, consumeReason })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        submit: async (dispatchRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/submit', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        delete: async (dispatchRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/delete', {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        approve: async (dispatchRequestId: string, commercialUserId?: string, platformEngineerId?: string) => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/approve', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId, commercialUserId, platformEngineerId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        reject: async (dispatchRequestId: string, reason: string) => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/reject', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId, reason })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        ready: async (dispatchRequestId: string) => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/ready', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        dispatch: async (dispatchRequestId: string, collectedBy: string) => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/dispatch', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId, collectedBy })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        close: async (dispatchRequestId: string, cancellationReason?: string) => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/dispatches/close', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ dispatchRequestId, cancellationReason })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        picklist: async (dispatchRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/dispatches/${dispatchRequestId}/picklist`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response)
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });

        },
        dispatchnote: async (dispatchNote: IDispatchNote) => {

            let headers = await getHeaders();
            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/dispatches/${dispatchNote.dispatchRequestId}/dispatchnote`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(dispatchNote)
                    }).then((response) => response)
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        uploadImage: async (dispatchRequestId: string, form: FormData) => {
            let headers = await getFormHeaders();


            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/dispatches/${dispatchRequestId}/images`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: form,
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        removeImage: async (dispatchRequestId: string, imageId: string) => {
            let headers = await getFormHeaders();
            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/dispatches/${dispatchRequestId}/images/${imageId}`, {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    console.log(err);
                    return reject(err);
                }
            });
        },

    },
    Materials: {
        Search: {
            owner: async (query: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch('api/v1/Materials/search/owner/' + query, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);
                    }
                });

            },
            description: async (query: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch('api/v1/Materials/search/descriptions/' + query, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);
                    }
                });
            },
            rack: async (warehouseId: string, query: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch('api/v1/Materials/search/warehouse/' + warehouseId + "/rack/" + query, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);
                    }
                });
            },
            row: async (warehouseId: string, query: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch('api/v1/Materials/search/warehouse/' + warehouseId + "/row/" + query, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {
                        return reject(err);
                    }
                });
            },
        },
        get: async (materialId: string) => {
            let headers = await getFormHeaders();
            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/materials/${materialId}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    console.log(err);
                    return reject(err);
                }
            });
        },
        create: async (material: IMaterial) => {

            let headers = await getHeaders();


            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/materials', {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(material)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });

        },
        update: async (material: IMaterial) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/materials', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(material)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });

        },
        uploadImage: async (materialId: string, form: FormData) => {
            let headers = await getFormHeaders();


            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/materials/${materialId}/images`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: form,
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        removeImage: async (materialId: string, imageId: string) => {
            let headers = await getFormHeaders();
            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/materials/${materialId}/images/${imageId}`, {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    console.log(err);
                    return reject(err);
                }
            });
        },
        import: async (form: FormData) => {
            let headers = await getFormHeaders();


            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/Import/material/import`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: form,
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        getImportTemplate: async () => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/Import/material/template', {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response)
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        getNextPallet: async () => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/Materials/pallets/next', {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        Audits: {
            get: async (materialId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch('api/v1/materials/' + materialId + '/audits', {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);

                    }
                });
            },
        },
        Dispatches: {
            get: async (materialId: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch('api/v1/materials/' + materialId + '/dispatches', {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);

                    }
                });
            },
        },
        Notes: {
            add: async (materialId: string, note: string) => {

                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/materials/${materialId}/notes`, {
                            method: 'POST',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: JSON.stringify(note)
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {
                        return reject(err);
                    }
                });
            },

        },
        StoredAssembly: {
            get: async (materialId: string) => {
                let headers = await getFormHeaders();
                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/materials/${materialId}/components`, {
                            method: 'GET',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {
                        console.log(err);
                        return reject(err);
                    }
                });
            },
        },
    },
    StorageRequests: {

        getAll: async () => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests', {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        getByStatus: async (status: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/storagerequests/status/${status}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        getByStatusPaged: async (status: string, request: IPagedRequest) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/storagerequests/status/${status}/page?${getPagedQueryString(request)}`, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        get: async (storageRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/' + storageRequestId, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },

        copy: async (copiedStorageRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/storagerequests/copy', {
                        method: 'POST',
                        headers: headers,

                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ copiedStorageRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },

        create: async () => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/storagerequests/draft', {
                        method: 'POST',
                        headers: headers,

                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: null
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        save: async (storageRequest: IStorageRequest) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(storageRequest)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        Materials: {
            remove: async (storageRequestId: string, materialId: string) => {
                let headers = await getHeaders();

                return new Promise((resolve, reject) => {
                    try {
                        fetch(`api/v1/storagerequests/${storageRequestId}/remove/${materialId}`, {
                            method: 'PUT',
                            headers: headers,
                            mode: 'cors',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                        }).then((response) => response.json())
                            .then((data) => {
                                return resolve(data);
                            });
                    } catch (err) {

                        return reject(err);

                    }
                });
            }
        },
        submit: async (storageRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/submit', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ storageRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        delete: async (storageRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/delete', {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ storageRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        approve: async (storageRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/approve', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ storageRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        reject: async (storageRequestId: string, reason: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/reject', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ storageRequestId, reason })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        close: async (storageRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/close', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ storageRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        alert: async (storageRequestId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/alert', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ storageRequestId })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);

                }
            });
        },
        complete: async (storageRequestId: string, cancellationReason?: string) => {

            console.log("completing!!!", cancellationReason);


            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/storagerequests/complete', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ storageRequestId, cancellationReason })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        uploadDocument: async (storageRequestId: string, form: FormData) => {
            let headers = await getFormHeaders();


            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/storagerequests/${storageRequestId}/documents`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: form,
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
        removeDocument: async (storageRequestId: string, documentId: string) => {
            let headers = await getFormHeaders();
            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/storagerequests/${storageRequestId}/documents/${documentId}`, {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    console.log(err);
                    return reject(err);
                }
            });
        },

    },
    Search: {
        materials: async (request: ISearchRequest) => {
            let headers = await getHeaders();

            return new Promise((resolve, reject) => {

                try {
                    fetch('api/v1/Search', {
                        method: 'POST',
                        headers: headers,

                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(request)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    return reject(err);
                }
            });
        },
        export: async (request: ISearchRequest) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/Search/export', {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(request)
                    }).then((response) => response)
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });

        },
        import: async (formData: FormData) => {
            let headers = await getFormHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/Search/import', {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    console.log(err);
                    return reject(err); // Reject the promise on error
                }
            });
        },

    },
    Reports: {
        export: async (request: IReportRequest) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/Report/export', {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(request)
                    }).then((response) => response)
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });

        },

    },
    Users: {
        getAll: async () => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/users', {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        getRoles: async () => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/users/roles', {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    return reject(err);
                }
            });
        },
        updateRole: async (id: string, roleId: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/users/${id}/role/${roleId}`, {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {
                    console.log(err);
                    return reject(err);
                }
            });
        },
        addUser: async (user: IUser) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/users', {
                        method: 'PUT',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify(user)
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });
        },
    },
    Values: {
        get: async (name: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch('api/v1/Values/' + name, {
                        method: 'GET',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        })


                } catch (err) {

                    return reject(err);

                }
            })
        },
        add: async (name: string, value: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/Values/${name}`, {
                        method: 'POST',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: JSON.stringify({ name, value })
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        });
                } catch (err) {

                    console.log(err);
                    return reject(err);

                }
            });

        },
        remove: async (name: string, id: string) => {

            let headers = await getHeaders();

            return new Promise((resolve, reject) => {
                try {
                    fetch(`api/v1/Values/${name}/${id}`, {
                        method: 'DELETE',
                        headers: headers,
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                    }).then((response) => response.json())
                        .then((data) => {
                            return resolve(data);
                        })


                } catch (err) {

                    return reject(err);

                }
            })
        }
    }
}

export default Api
